// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"897d79a9","100":"160da443","182":"a77b0885","488":"03ecc79f","508":"08b70053"}[chunkId] + ".chunk.js";
};